var _rect, _path, _rect2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgDebtlessnessOrange = function SvgDebtlessnessOrange(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 80 80"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 72,
    x: 10,
    y: 4,
    fill: "url(#debtlessness-orange_svg__a)",
    rx: 8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M56 34h4a2 2 0 0 0 2-2V14a2 2 0 0 0-2-2H20a2 2 0 0 0-2 2v18a2 2 0 0 0 2 2h27"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 28,
    x: 46,
    y: 40,
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    rx: 7
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "debtlessness-orange_svg__a",
    x1: 70.733,
    x2: 9.969,
    y1: 38.887,
    y2: 38.985,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5BE60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5BE60",
    stopOpacity: 0.2
  })))));
};
export default SvgDebtlessnessOrange;